module.exports = __webpack_public_path__ + "assets/target-fda334.svg";